import { useContext } from "react";
import { EventOffer } from "@gp/offer";
import { useLocation } from "react-router";
import min from "lodash/min";
import { SetIsAdditionalOfferOpenCtxProviderForParentLayout } from "@state/context/additional-offer/SetIsAdditionalOfferOpenCtxProviderForParentLayout";
import {
	addToUrlParams,
	getUrlParamsAsObj,
	removeFromUrlParams,
	HistoryState,
} from "@state";

export function isAdditionalOfferOpenFor(eventId: string): boolean {
	return getUrlParamsAsObj<{ eventId: string }>().eventId === eventId;
}

export function additionalOfferToggle(
	event: EventOffer,
	betBuilderDisplayGroup: string,
	state?: HistoryState | null
) {
	if (!isAdditionalOfferOpenFor(event.id)) {
		additionalOfferOpen(event, betBuilderDisplayGroup, state);
	} else {
		additionalOfferClose(state);
	}
}

export function additionalOfferOpen(
	event: EventOffer,
	betBuilder: string = "",
	state?: HistoryState | null
) {
	addToUrlParams(
		{
			eventId: event.id,
			sportId: event.sportId,
			isAdditionalLive: event.isLive,
			myBets: getUrlParamsAsObj<{ myBets: string }>().myBets === "true",
			bb: betBuilder,
		},
		true,
		state
	);
}

export function additionalOfferClose(state?: HistoryState | null) {
	removeFromUrlParams(
		["eventId", "sportId", "isAdditionalLive", "myBets", "bb"],
		true,
		state
	);
}

export function useNumberOfAvailableColumns(availableColumns: number): number {
	const isAdditionalOfferVisible = useContext(
		SetIsAdditionalOfferOpenCtxProviderForParentLayout
	).isAdditionalOpen;
	return min([
		isAdditionalOfferVisible
			? Math.floor(availableColumns / 2)
			: availableColumns,
		isAdditionalOfferVisible ? 2 : 4,
	]) as number;
}

export function useGetAdditionalOfferEvent():
	| {
			eventId: string;
			sportId: string;
			tipId?: string | null;
	  }
	| undefined {
	// This is required to trigger rerender
	useLocation();

	const additionalOffer = getUrlParamsAsObj<{
		eventId?: string;
		sportId?: string;
		tipId?: string;
	}>();
	if (
		additionalOffer.eventId == null ||
		additionalOffer.eventId == undefined ||
		additionalOffer.sportId == null
	) {
		return undefined;
	}

	return {
		eventId: additionalOffer.eventId,
		sportId: additionalOffer.sportId,
		tipId: additionalOffer.tipId || null,
	};
}

export function useIsAdditionalOfferVisible(): boolean {
	return useContext(SetIsAdditionalOfferOpenCtxProviderForParentLayout)
		.isAdditionalOpen;
}

export function useGetIsAdditionalLive(): boolean {
	// This is required to trigger rerender
	useLocation();
	return (
		getUrlParamsAsObj<{ isAdditionalLive?: boolean }>().isAdditionalLive ===
		true
	);
}
